import { Autocomplete, TextField } from '@mui/material';
import React, { useEffect } from 'react'
import { useState } from 'react';
import { useRecoilCallback, useRecoilState, useResetRecoilState, useSetRecoilState } from 'recoil';
import useCatchErrorApi from 'src/shared/hooks/useCatchErrorApi';
import InputLabelCustom from '../../../shared/components/forms/InputLabelCustom';
import AutocompleteSkeleton from '../../../shared/components/skeletons/AutocompleteSkeleton';
import { capitalizeWords, finderProcedimientoByName } from '../../../shared/global/helpers';
import { daysAvailableState, filterSearchSelectedState, isChangeFormSearchState } from '../../state/atoms';
import { dayDefaultAvailableState } from '../calendars/state/atoms';
import { professionalsBySpecialityState,professionalsByServiceState, professionalsState, procedimientosState } from './state/atoms';

const AutocompleteProcedimiento = ({ size = "small", styles }) =>  {
    const { catchErrorApi } = useCatchErrorApi();
    const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
    const [filterSearchSelected, setFilterSearchSelected] = useRecoilState(filterSearchSelectedState);
    //const [professionals, setProfessionals] = useRecoilState(professionalsState);
    const [procedimientos, setProcedimientos] = useRecoilState(procedimientosState);
    const [loading, setLoading] = useState(false);
    const resetDayDefaultAvailable = useResetRecoilState(dayDefaultAvailableState);
    const resetDaysAvailable = useResetRecoilState(daysAvailableState);


  return (
    <> 
    <InputLabelCustom htmlFor="autocomplete-procedimiento" text="Procedimiento" style={{ ...styles.label }} />
    <Autocomplete
        style={{ ...styles.autocomplete }}
        size={size}
        id="autocomplete-procedimiento"
        options={procedimientos && procedimientos.map((option) => `${option.agpNombre}`)}
        getOptionLabel={option => capitalizeWords(option) || null}
        value={filterSearchSelected.procedimientoSelected.value || null}
        noOptionsText="Sin resultados"
        onChange={(event, value, reason) => {
            setIsChangeFormSearch(true);
            resetDayDefaultAvailable();
            resetDaysAvailable();
            if (reason === 'clear') {
                setFilterSearchSelected({
                    ...filterSearchSelected,
                    procedimientoSelected: {
                        ...filterSearchSelected.procedimientoSelected,
                        value: '',
                        code: null,
                        rut: null,
                    }
                });

                return;
            }

            if (reason === 'selectOption') {
                const finderProdedimiento = finderProcedimientoByName(procedimientos, value);
                setFilterSearchSelected({
                    ...filterSearchSelected,
                    procedimientoSelected: {
                        ...filterSearchSelected.procedimientoSelected,
                        value: value,
                        code: finderProdedimiento?.agpCorrel,
                        rut: finderProdedimiento?.ptdRut
                    }
                })
            }
        }}
        renderInput={(params) => <TextField {...params} placeholder="Buscar" variant="outlined" />}
    />
</>
  )
}

export default AutocompleteProcedimiento